import anytimeConsultationShiftApi from "../../api/anytime_consultation_shifts";
import * as mutationTypes from "../mutation-types";

const state = {
  anytimeConsultationShifts: []
};

const getters = {
  anytimeConsultationShifts : state => state.anytimeConsultationShifts,
};

const actions = {
  fetchAnytimeConsultationShifts({ commit }, params) {
    return new Promise((resolve) => {
      anytimeConsultationShiftApi.fetchAnytimeConsultationShifts(anytimeConsultationShifts => {
        commit(mutationTypes.ASSIGN_ANYTIME_CONSULTATION_SHIFTS, { anytimeConsultationShifts });
        resolve();
      }, params);
    });
  },
};

const mutations = {
  [mutationTypes.ASSIGN_ANYTIME_CONSULTATION_SHIFTS](state, { anytimeConsultationShifts }) {
    state.anytimeConsultationShifts = anytimeConsultationShifts;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
